import { mapUploadToAlbumImage } from '@pixum/image-service/lib/map-upload-to-album-image';
import type { OnThumbnail, ThumbnailGenerationResponse, Upload } from '@pixum/types';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

export function onThumbnail(updater: ImageStateUpdater): OnThumbnail {
  return (thumbnail: ThumbnailGenerationResponse, upload: Upload) =>
    updater.updateImage({
      ...mapUploadToAlbumImage(upload),
      height: thumbnail.height,
      width: thumbnail.width,
      rotatedHeight: thumbnail.height,
      rotatedWidth: thumbnail.width,
      urlThumbBig: thumbnail.url,
      urlThumbSmall: thumbnail.url,
    });
}
